import polyglot from './reducer'
import * as polyglotActions from './actions'
import * as polyglotTypes from './types'

export {polyglotActions, polyglotTypes}
export default polyglot
